module.exports = __webpack_public_path__ + "static/media/viewfullview.ca74bc49.svg";